import React, { useState, useEffect, useRef, useCallback } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import QuestionInfo from "./../QuestionInfo/QuestionInfo";
import PercentageResponse from "./../PercentageResponse/PercentageResponse";
import PercentageAnswer from "./../PercentageAnswer/PercentageAnswer";
import RankingAllResponse from "./../RankingAllResponse/RankingAllResponse";
import RankingAllAnswer from "./../RankingAllAnswer/RankingAllAnswer";
import SelectTop1Response from "./../SelectTop1Response/SelectTop1Response";
import SelectTop1Answer from "./../SelectTop1Answer/SelectTop1Answer";
import PieResponse from "./../PieResponse/PieResponse";
import PieAnswer from "./../PieAnswer/PieAnswer";
import LikertResponse from "./../LikertResponse/LikertResponse";
import LikertAnswer from "./../LikertAnswer/LikertAnswer";
import Likert3SidesResponse from "./../Likert3SidesResponse/Likert3SidesResponse";
import Likert3SidesAnswer from "./../Likert3SidesAnswer/Likert3SidesAnswer";
import Legend from "./../Legend/Legend";
import GameStopSideBar from "./../GameStopSideBar/GameStopSideBar";
import Header from "./../Header/Header";
import {
	QUESTION_PROMPT_PERCENTAGE_GUESS,
	QUESTION_PROMPT_PIE,
	QUESTION_PROMPT_RANKING_ALL,
	QUESTION_PROMPT_TOP_1,
	QUESTION_PROMPT_LIKERT,
	QUESTIONS_PER_GAME_STOP,
	GAME_STOP_NUMBER,
} from "./../../constants.js";
import "./Display.scss";
import questionMark from "./../../assets/img/questionmark_grayscale.svg";
import campaignWeathervaneLogo from "./../../assets/img/campaign-weathervane-logo.webp";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import AboutGameScoreModal from "../AboutGameScore/AboutGameScoreModal";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const questionTypeEnum = {
	BINARY: "Binary/DK",
	YES_NO: "Yes/No",
	L3: "L3 Likert 3 + D/K",
	L4: "L4 Likert 4 + D/K",
	L5: "L5 Likert 5 + D/K",
	OPEN_END: "Open end",
	SIMPLE_LIST: "Simple List",
};

export const questionDisplayFormatEnum = {
	PERCENTAGE_GUESS: 1,
	RANK_ALL: 2,
	TOP_1: 3,
	PIE: 4,
	LIKERT_2_SIDES: 5,
	LIKERT_3_SIDES: 6,
};

function Display(props) {
	const data = require("./../../assets/data/data.json") || props.gameData;
	const [currentNumber, setCurrentNumber] = useState(1);
	const [score, setScore] = useState(props.gameState.score || 50);
	const [scoreChange, setScoreChange] = useState(0);
	const [showAnswer, setShowAnswer] = useState(false);
	const [answer, setAnswer] = useState([]);
	const [shuffledOptions, setShuffledOptions] = useState([]);
	const [responseSubmitted, setResponseSubmitted] = useState(false);
	const [response, setResponse] = useState(0);
	const [uniqueIDs, setUniqueIDs] = useState([]); //to track which questions have appeared
	const [uniqueQuestionTxt, setUniqueQuestionTxt] = useState([]);
	const [surveyStartDate, setSurveyStartDate] = useState("");
	const [surveyEndDate, setSurveyEndDate] = useState("");
	const [surveyAudience, setSurveyAudience] = useState("");
	const [surveyOrganization, setSurveyOrganization] = useState("");
	const [surveySponsor, setSurveySponsor] = useState("");
	const [surveyQuestion, setSurveyQuestion] = useState("");
	const [questionDisplayFormat, setQuestionDisplayFormat] = useState(0);
	const gameStopNumber = props.gameState.gameStopNumber || 1;
	const timeline = props.gameState.timeline;
	const [firstPercentageGuess, setFirstPercentageGuess] = useState(
		typeof props.gameState.firstPercentageGuess == "undefined" ? true : props.gameState.firstPercentageGuess
	);
	const [firstRankAll, setFirstRankAll] = useState(
		typeof props.gameState.firstRankAll == "undefined" ? true : props.gameState.firstRankAll
	);
	const [firstTop1, setFirstTop1] = useState(
		typeof props.gameState.firstTop1 == "undefined" ? true : props.gameState.firstTop1
	);
	const [firstPie, setFirstPie] = useState(
		typeof props.gameState.firstPie == "undefined" ? true : props.gameState.firstPie
	);
	const [firstLikert2Sides, setFirstLikert2Sides] = useState(
		typeof props.gameState.firstLikert2Sides == "undefined" ? true : props.gameState.firstLikert2Sides
	);
	const [firstLikert3Sides, setFirstLikert3Sides] = useState(
		typeof props.gameState.firstLikert3Sides == "undefined" ? true : props.gameState.firstLikert3Sides
	);
	const [isOpenEnd, setIsOpenEnd] = useState(false);
	const [responseLegends, setResponseLegends] = useState([]);
	const [answerLegends, setAnswerLegends] = useState([]);
	const [scorePopUpOpen, setScorePopUpOpen] = useState(false);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [questionHasCutOff, setQuestionHasCutOff] = useState(false);

	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};

	const scoreForGain = 50 / (QUESTIONS_PER_GAME_STOP * GAME_STOP_NUMBER);

	function handleNextQuestion() {
		window.scrollTo(0, 0);
		if (currentNumber === QUESTIONS_PER_GAME_STOP) {
			if (gameStopNumber === GAME_STOP_NUMBER) {
				props.navigate(3, { score: score, timeline: timeline });
			} else {
				// current number state is set to 0 so that the side timeline bar doesn't render
				props.navigate(2, {
					score: score,
					timeline: timeline,
					gameStopNumber: gameStopNumber + 1,
					firstPercentageGuess: firstPercentageGuess,
					firstRankAll: firstRankAll,
					firstTop1: firstTop1,
					firstPie: firstPie,
					firstLikert2Sides: firstLikert2Sides,
					firstLikert3Sides: firstLikert3Sides,
				});
			}
		} else {
			setCurrentNumber(currentNumber + 1);
			setResponseSubmitted(false);
			setShowAnswer(false);
			setNewQuestion();
			setIsOpenEnd(false);
		}
	}

	function handleLockInResponse(response) {
		// Scroll back to Top
		window.scrollTo(0, 0);
		if (!responseSubmitted) {
			setResponse(response);
			var change = 0; //based on what users see on the score meter
			if (questionDisplayFormat === questionDisplayFormatEnum.PIE) {
				// response is in the form of [top1 id, top2 id, top3 id]
				// +100% of earnable score for all correct slices placed;
				// 0% of earnable score for one correct slice placed;
				// -100% of earnable score for all wrong slices placed
				if (response[0] === answer[0].id && response[1] === answer[1].id && response[2] === answer[2].id) {
					setScore(score + scoreForGain);
					change = Math.round(score + scoreForGain) - Math.round(score);
					// handleScorePopUpOpen() // disabled for now, but uncomment it out when want to display score in the middle of the page after every question
				} else if (
					response[0] !== answer[0].id &&
					response[1] !== answer[1].id &&
					response[2] !== answer[2].id
				) {
					setScore(score - scoreForGain);
					change = Math.round(score - scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				}
				setFirstPie(false);
			} else if (questionDisplayFormat === questionDisplayFormatEnum.PERCENTAGE_GUESS) {
				// +100% of earnable score for answer +/-10% of true value
				// +50% of earnable score for answer +/-20% of true value
				// 0% of earnable score for answer +/-30% of true value
				// -100% of earnable score for remaining answers
				const diff = Math.abs(response - answer[0].percent);
				if (diff <= 10) {
					setScore(score + scoreForGain);
					change = Math.round(score + scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff <= 20) {
					setScore(score + scoreForGain / 2);
					change = Math.round(score + scoreForGain / 2) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff > 30) {
					setScore(score - scoreForGain);
					change = Math.round(score - scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				}
				setFirstPercentageGuess(false);
			} else if (questionDisplayFormat === questionDisplayFormatEnum.RANK_ALL) {
				let deviation = 0;
				response.forEach((element, index) => {
					deviation += Math.abs(element.id - index);
				});
				// Max deviation for 4 options is 8 and for 5 options is 12
				// For 4 options,
				// +100% of earnable score for answer with 0 deviation
				// +_% of earnable score proportionally for answer with less than 4 deviation
				// -_% of earnable score proportionally for answer with more than 4 deviation
				// -100% of earnable score for answer with 8 deviation
				// For 5 options,
				// +100% of earnable score for answer with 0 deviation
				// +_% of earnable score proportionally for answer with less than 6 deviation
				// -_% of earnable score proportionally for answer with more than 4 deviation
				// -100% of earnable score for answer with 12 deviation
				const gainLoss =
					answer.length === 4 ? ((4 - deviation) / 4) * scoreForGain : ((6 - deviation) / 6) * scoreForGain;
				setScore(score + gainLoss);
				setFirstRankAll(false);
				change = Math.round(score + gainLoss) - Math.round(score);
				// handleScorePopUpOpen()
			} else if (questionDisplayFormat === questionDisplayFormatEnum.TOP_1) {
				// response is the deviation
				const gainLoss =
					((Math.floor(answer.length / 2) - response) / Math.floor(answer.length / 2)) * scoreForGain;
				setScore(score + gainLoss);
				setFirstTop1(false);
				change = Math.round(score + gainLoss) - Math.round(score);
				// handleScorePopUpOpen()
			} else if (questionDisplayFormat === questionDisplayFormatEnum.LIKERT_2_SIDES) {
				// response percentage corresponds to increasing value from left to right on slider
				const diff = Math.abs(response - answer[0].percent);
				if (diff <= 10) {
					setScore(score + scoreForGain);
					change = Math.round(score + scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff <= 20) {
					setScore(score + scoreForGain / 2);
					change = Math.round(score + scoreForGain / 2) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff > 30) {
					setScore(score - scoreForGain);
					change = Math.round(score - scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				}
				setFirstLikert2Sides(false);
			} else if (questionDisplayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES) {
				// response is in the form of [leftPercentage, rightPercentage] of the fixed bar
				const movableValue = 100 - response[1] + response[0];
				const diff = Math.abs(response[0] - answer[0].percent);
				if (diff <= (10 / 50) * movableValue) {
					setScore(score + scoreForGain);
					change = Math.round(score + scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff <= (20 / 50) * movableValue) {
					setScore(score + scoreForGain / 2);
					change = Math.round(score + scoreForGain / 2) - Math.round(score);
					// handleScorePopUpOpen()
				} else if (diff > (30 / 50) * movableValue) {
					setScore(score - scoreForGain);
					change = Math.round(score - scoreForGain) - Math.round(score);
					// handleScorePopUpOpen()
				}
				setFirstLikert3Sides(false);
			}
		}
		setResponseSubmitted(true);
		setShowAnswer(true);
		setScoreChange(change);
	}

	function handleScorePopUpOpen() {
		setScorePopUpOpen(true);
		setTimeout(function () {
			setScorePopUpOpen(false);
		}, 2500);
	}

	function handleScorePopUpClose() {
		setScorePopUpOpen(false);
	}

	function combineSurveyAudience(questionData) {
		if (questionData.SubPopulation) {
			return questionData.SampleDesc + "; " + questionData.SubPopulation;
		} else {
			return questionData.SampleDesc;
		}
	}

	function getValidOptionCount(responseFormat, numOptions, questionData) {
		let count = 0;
		if (responseFormat === questionTypeEnum.L3) {
			for (let i = 0; i < 3; i++) {
				if (questionData[i].RespPct !== "*") {
					count++;
				}
			}
		} else if (responseFormat === questionTypeEnum.L4) {
			for (let i = 0; i < 4; i++) {
				if (questionData[i].RespPct !== "*") {
					count++;
				}
			}
		} else if (responseFormat === questionTypeEnum.L5) {
			for (let i = 0; i < 5; i++) {
				if (questionData[i].RespPct !== "*") {
					count++;
				}
			}
		} else if (
			(responseFormat === questionTypeEnum.OPEN_END || responseFormat === questionTypeEnum.SIMPLE_LIST) &&
			numOptions == 3
		) {
			for (let i = 0; i < 3; i++) {
				if (questionData[i].RespPct !== "*") {
					count++;
				}
			}
		}
		return count;
	}

	function getQuestionDisplayFormat(responseFormat, numOptions, answerOptionsData) {
		const validOptionCount = getValidOptionCount(responseFormat, numOptions, answerOptionsData);
		if (responseFormat === questionTypeEnum.BINARY || responseFormat === questionTypeEnum.YES_NO) {
			return questionDisplayFormatEnum.PERCENTAGE_GUESS;
		} else if (responseFormat === questionTypeEnum.L3) {
			if (validOptionCount < 3) {
				return questionDisplayFormatEnum.PERCENTAGE_GUESS;
			} else {
				return questionDisplayFormatEnum.LIKERT_3_SIDES;
			}
		} else if (responseFormat === questionTypeEnum.L5) {
			if (validOptionCount == 5 || validOptionCount == 3) {
				return questionDisplayFormatEnum.LIKERT_3_SIDES;
			} else if (validOptionCount == 4) {
				return questionDisplayFormatEnum.LIKERT_2_SIDES;
			}
		} else if (responseFormat === questionTypeEnum.L4) {
			if (validOptionCount == 4) {
				return questionDisplayFormatEnum.LIKERT_2_SIDES;
			} else if (validOptionCount == 3) {
				return questionDisplayFormatEnum.LIKERT_3_SIDES;
			} else if (validOptionCount == 2) {
				return questionDisplayFormatEnum.PERCENTAGE_GUESS;
			}
		} else if (responseFormat === questionTypeEnum.OPEN_END || responseFormat === questionTypeEnum.SIMPLE_LIST) {
			if (responseFormat === questionTypeEnum.OPEN_END) {
				setIsOpenEnd(true);
			}
			if (numOptions > 5) {
				return questionDisplayFormatEnum.TOP_1;
			} else if (numOptions <= 3) {
				if (validOptionCount == 2) {
					return questionDisplayFormatEnum.PERCENTAGE_GUESS;
				} else {
					return questionDisplayFormatEnum.PIE;
				}
			} else {
				return questionDisplayFormatEnum.RANK_ALL;
			}
		}
	}

	function sortAnswers(answers) {
		var sorted = [...answers];
		sorted.sort(function (a, b) {
			return b.RespPct - a.RespPct;
		});
		return sorted;
	}

	function shuffle(answers) {
		var shuffled = [...answers];
		shuffled.sort(() => Math.random() - 0.5);
		return shuffled;
	}


	function applyCutoff(options) {
		if(options[0].CutOff){
			return options.filter((option) => option.RespPct >= option.CutOff);
		} else{
			return options;
		}
	}

	/** for response percentage < 0.5%, we want to exclude them from displaying (only mention in footnote) */
	function getAnswerByFormat(answerOptionsData, responseFormat, displayFormat, numOptions) {
		var answerOptions = [];
		answerOptionsData = applyCutoff(answerOptionsData); // apply cutoff if it exists
		const validOptionCount = getValidOptionCount(responseFormat, numOptions, answerOptionsData);
		if (displayFormat === questionDisplayFormatEnum.RANK_ALL || displayFormat === questionDisplayFormatEnum.TOP_1) {
			// ids of answer state will be in order from most popular to least popular
			answerOptionsData = filterResponseOptions(answerOptionsData);
			answerOptionsData = sortAnswers(answerOptionsData);
			for (let i = 0; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					answerOptions.push({
						id: i.toString(),
						content: answerOptionsData[i].RespTxt,
						percent: answerOptionsData[i].RespPct,
					});
				}
			}
			setShuffledOptions(shuffle(answerOptions));
		} else if (displayFormat === questionDisplayFormatEnum.PIE) {
			const newAnswerOptionsData = sortAnswers(answerOptionsData.slice(0, 3));
			for (let i = 0; i < 3; i++) {
				answerOptions.push({
					id: i.toString(),
					content: newAnswerOptionsData[i].RespTxt,
					percent: newAnswerOptionsData[i].RespPct,
				});
			}
			setShuffledOptions(shuffle(answerOptions));

			var otherOptions = {
				id: "3",
				content: "",
				percent: 0,
			};

			for (let i = 3; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					otherOptions.content +=
						otherOptions.content === ""
							? answerOptionsData[i].RespTxt
							: " / " + answerOptionsData[i].RespTxt;
					otherOptions.percent += answerOptionsData[i].RespPct;
				}
			}
			answerOptions.push(otherOptions);
		} else if (displayFormat === questionDisplayFormatEnum.PERCENTAGE_GUESS) {
			//Pick the first option as the target response to guess on
			answerOptions.push({
				id: 0,
				content: answerOptionsData[0].RespTxt,
				percent: answerOptionsData[0].RespPct,
			});
			answerOptions.push({
				id: 1,
				content: answerOptionsData[1].RespTxt,
				percent: answerOptionsData[1].RespPct,
			});
			var otherOptions = {
				id: 2,
				content: "",
				percent: 0,
			};

			for (let i = 2; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					otherOptions.content +=
						otherOptions.content === ""
							? answerOptionsData[i].RespTxt
							: " / " + answerOptionsData[i].RespTxt;
					otherOptions.percent += answerOptionsData[i].RespPct;
				}
			}
			answerOptions.push(otherOptions);
		} else if (displayFormat === questionDisplayFormatEnum.LIKERT_2_SIDES) {
			answerOptions.push({
				id: 0,
				content: answerOptionsData[0].RespTxt + " / " + answerOptionsData[1].RespTxt,
				percent: answerOptionsData[0].RespPct + answerOptionsData[1].RespPct,
			});
			answerOptions.push({
				id: 1,
				content: answerOptionsData[2].RespTxt + " / " + answerOptionsData[3].RespTxt,
				percent: answerOptionsData[2].RespPct + answerOptionsData[3].RespPct,
			});
			var otherOptions = {
				id: 2,
				content: "",
				percent: 0,
			};
			for (let i = 4; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					otherOptions.content +=
						otherOptions.content === ""
							? answerOptionsData[i].RespTxt
							: " / " + answerOptionsData[i].RespTxt;
					otherOptions.percent += answerOptionsData[i].RespPct;
				}
			}
			answerOptions.push(otherOptions);
		} else if (displayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES && validOptionCount === 3) {
			for (let i = 0; i < 3; i++) {
				answerOptions.push({
					id: i.toString(),
					content: answerOptionsData[i].RespTxt,
					percent: answerOptionsData[i].RespPct,
				});
			}
			var otherOptions = {
				id: 3,
				content: "",
				percent: 0,
			};

			for (let i = 3; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					otherOptions.content +=
						otherOptions.content === ""
							? answerOptionsData[i].RespTxt
							: " / " + answerOptionsData[i].RespTxt;
					otherOptions.percent += answerOptionsData[i].RespPct;
				}
			}
			answerOptions.push(otherOptions);
		} else if (displayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES && validOptionCount == 5) {
			answerOptions.push({
				id: 0,
				content: answerOptionsData[0].RespTxt + " / " + answerOptionsData[1].RespTxt,
				percent: answerOptionsData[0].RespPct + answerOptionsData[1].RespPct,
			});
			answerOptions.push({
				id: 1,
				content: answerOptionsData[2].RespTxt,
				percent: answerOptionsData[2].RespPct,
			});
			answerOptions.push({
				id: 2,
				content: answerOptionsData[3].RespTxt + " / " + answerOptionsData[4].RespTxt,
				percent: answerOptionsData[3].RespPct + answerOptionsData[4].RespPct,
			});
			var otherOptions = {
				id: 3,
				content: "",
				percent: 0,
			};

			for (let i = 5; i < answerOptionsData.length; i++) {
				if (answerOptionsData[i].RespPct !== "*") {
					otherOptions.content +=
						otherOptions.content === ""
							? answerOptionsData[i].RespTxt
							: " / " + answerOptionsData[i].RespTxt;
					otherOptions.percent += answerOptionsData[i].RespPct;
				}
			}
			answerOptions.push(otherOptions);
		}
		return answerOptions;
	}

	function filterResponseOptions(answerOptionsData) {
		var filteredResponseData = [];
		// Captions can be used in combination with each other, separated with a slash: Eg. Don't know/no opinion.
		// Nearly all of these have (vol) after them, to indicate that the response was volunteered.
		const captions = [
			"Don't know",
			"DK",
			"Refused",
			"No opinion",
			"No answer",
			"Skipped",
			"Skipped on web",
			"Does not apply",
			"NA",
			"Not applicable",
			"Can't choose",
			"Can't respond",
			"Can't answer",
			"Can't say",
			"Won't answer",
			"No response",
			"Don't know written",
			"Don't know box checked",
		];
		answerOptionsData.forEach((option) => {
			let processedOptionTxt = option.RespTxt.split("/")[0].split("(")[0]; //To split from combination of captions and (vol)
			if (!captions.includes(processedOptionTxt)) {
				filteredResponseData.push(option);
			}
		});
		return filteredResponseData;
	}

	function getResponseLegends(displayFormat, answer) {
		var labels = [];
		if (
			displayFormat === questionDisplayFormatEnum.PERCENTAGE_GUESS ||
			displayFormat === questionDisplayFormatEnum.LIKERT_2_SIDES
		) {
			let scale = answer[0].percent + answer[1].percent;
			labels = [
				{
					value: `${answer[0].content} (${response}%)`,
					color: "#B2292D",
					opacity: 1,
					legendTextColor: "black",
				},
				{
					value: `${answer[1].content} (${scale - response}%)`,
					color: "#5B6586",
					opacity: 1,
					legendTextColor: "black",
				},
			];
			if (answer[2].percent > 0) {
				labels.push({
					value: `${answer[2].content} (${answer[2].percent}%)`,
					color: "#E7DCDA",
					opacity: 1,
					legendTextColor: "#595959",
				});
			}
		} else if (displayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES) {
			let scale = answer[0].percent + answer[1].percent + answer[2].percent;
			var left = typeof response[0] == "undefined" ? 0 : response[0];
			var right = typeof response[1] == "undefined" ? scale - answer[1].percent : scale - response[1];
			labels = [
				{
					value: `${answer[0].content} (${left}%)`,
					color: "#B2292D",
					opacity: 1,
					legendTextColor: "black",
				},
				{
					value: `${answer[1].content} (${answer[1].percent}%)`,
					color: "#f4d06f",
					opacity: 1,
					legendTextColor: "grey",
				},
				{
					value: `${answer[2].content} (${right}%)`,
					color: "#5B6586",
					opacity: 1,
					legendTextColor: "black",
				},
			];
			if (answer[3].percent > 0) {
				labels.push({
					value: `${answer[3].content} (${answer[3].percent}%)`,
					color: "#E7DCDA",
					opacity: 1,
					legendTextColor: "grey",
				});
			}
		}
		return labels;
	}

	function getAnswerLegends(displayFormat, answer) {
		var labels = [];
		if (
			displayFormat === questionDisplayFormatEnum.PERCENTAGE_GUESS ||
			displayFormat === questionDisplayFormatEnum.LIKERT_2_SIDES
		) {
			labels = [
				{
					value: `${answer[0].content} (${answer[0].percent}%)`,
					color: "#B2292D",
					opacity: 1,
					legendTextColor: "black",
				},
				{
					value: `${answer[1].content} (${answer[1].percent}%)`,
					color: "#5B6586",
					opacity: 1,
					legendTextColor: "black",
				},
			];
			if (answer[2].percent > 0) {
				labels.push({
					value: `${answer[2].content} (${answer[2].percent}%)`,
					color: "#E7DCDA",
					opacity: 1,
					legendTextColor: "black",
				});
			}
		} else if (displayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES) {
			labels = [
				{
					value: `${answer[0].content} (${answer[0].percent}%)`,
					color: "#B2292D",
					opacity: 1,
					legendTextColor: "black",
				},
				{
					value: `${answer[1].content} (${answer[1].percent}%)`,
					color: "#f4d06f",
					opacity: 1,
					legendTextColor: "black",
				},
				{
					value: `${answer[2].content} (${answer[2].percent}%)`,
					color: "#5B6586",
					opacity: 1,
					legendTextColor: "black",
				},
			];
			if (answer[3].percent > 0) {
				labels.push({
					value: `${answer[3].content} (${answer[3].percent}%)`,
					color: "#E7DCDA",
					opacity: 1,
					legendTextColor: "black",
				});
			}
		}
		return labels;
	}

	function setNewQuestion() {
		var questions = data.filter(function (el) {
			return (
				el["Station Number"] === gameStopNumber &&
				(!uniqueIDs.includes(el.QuestionID) || !uniqueQuestionTxt.includes(el.QuestionTxt)) &&
				el["Election"] === timeline
			);
		});
		var question = questions[0];
		setSurveyQuestion(question.QuestionTxt);
		setQuestionHasCutOff(question.CutOff ? true : false);
		setSurveyAudience(combineSurveyAudience(question));
		setSurveyStartDate(question.BegDate);
		setSurveyEndDate(question.EndDate);
		setSurveyOrganization(question.SurveyOrg);
		setSurveySponsor(question.SurveySponsor);
		setUniqueIDs([...uniqueIDs, question.QuestionID]);
		setUniqueQuestionTxt([...uniqueQuestionTxt, question.QuestionTxt]);
		var answerOptionsData = questions.filter(function (el) {
			return el.QuestionID === question.QuestionID && el.QuestionTxt === question.QuestionTxt;
		});
		var numOptions = filterResponseOptions(answerOptionsData).length;
		const newDisplayFormat = getQuestionDisplayFormat(question["Response Format"], numOptions, answerOptionsData);
		setQuestionDisplayFormat(newDisplayFormat);
		const newAnswer = getAnswerByFormat(
			answerOptionsData,
			question["Response Format"],
			newDisplayFormat,
			numOptions
		);
		setAnswer(newAnswer);
		setResponseLegends(getResponseLegends(newDisplayFormat, newAnswer));
		setAnswerLegends(getAnswerLegends(newDisplayFormat, newAnswer));
	}

	// placed in front of the next useEffect
	// since on the first render, questionDisplayFormat and answer is not yet defined
	// and the legend will come from setNewQuestion
	useEffect(() => {
		setResponseLegends(getResponseLegends(questionDisplayFormat, answer));
	}, [response]);

	useEffect(() => {
		setNewQuestion();
	}, []);

	var questionPrompt;
	var ResponseComponent;
	var AnswerComponent;
	if (questionDisplayFormat === questionDisplayFormatEnum.PERCENTAGE_GUESS) {
		questionPrompt = QUESTION_PROMPT_PERCENTAGE_GUESS;
		ResponseComponent = (
			<PercentageResponse
				key={currentNumber}
				answer={answer}
				setResponse={setResponse}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstPercentageGuess}
				setDisplayTooltip={setFirstPercentageGuess}
			/>
		);
		AnswerComponent = <PercentageAnswer answer={answer} response={response} />;
	} else if (questionDisplayFormat === questionDisplayFormatEnum.RANK_ALL) {
		questionPrompt = QUESTION_PROMPT_RANKING_ALL;
		ResponseComponent = (
			<RankingAllResponse
				key={currentNumber}
				options={shuffledOptions}
				setShuffledOptions={setShuffledOptions}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstRankAll}
				setDisplayTooltip={setFirstRankAll}
				handleLockInResponse={handleLockInResponse}
			/>
		);
		AnswerComponent = <RankingAllAnswer answer={answer} isOpenEnd={isOpenEnd} />;
	} else if (questionDisplayFormat === questionDisplayFormatEnum.TOP_1) {
		questionPrompt = QUESTION_PROMPT_TOP_1;
		ResponseComponent = (
			<SelectTop1Response
				key={currentNumber}
				options={shuffledOptions}
				setResponse={setResponse}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstTop1}
				setDisplayTooltip={setFirstTop1}
				handleLockInResponse={handleLockInResponse}
			/>
		);
		AnswerComponent = <SelectTop1Answer answer={answer} isOpenEnd={isOpenEnd} />;
	} else if (questionDisplayFormat === questionDisplayFormatEnum.PIE) {
		questionPrompt = QUESTION_PROMPT_PIE;
		ResponseComponent = (
			<PieResponse
				key={currentNumber}
				options={shuffledOptions}
				answer={answer}
				setResponse={setResponse}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstPie}
				setDisplayTooltip={setFirstPie}
				handleLockInResponse={handleLockInResponse}
			/>
		);
		AnswerComponent = <PieAnswer answer={answer} isAnswerComponent={true} response={response} />;
	} else if (questionDisplayFormat === questionDisplayFormatEnum.LIKERT_2_SIDES) {
		questionPrompt = QUESTION_PROMPT_LIKERT;
		ResponseComponent = (
			<LikertResponse
				key={currentNumber}
				answer={answer}
				setResponse={setResponse}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstLikert2Sides}
				setDisplayTooltip={setFirstLikert2Sides}
			/>
		);
		AnswerComponent = <LikertAnswer answer={answer} />;
	} else if (questionDisplayFormat === questionDisplayFormatEnum.LIKERT_3_SIDES) {
		questionPrompt = QUESTION_PROMPT_LIKERT;
		ResponseComponent = (
			<Likert3SidesResponse
				key={currentNumber}
				answer={answer}
				setResponse={setResponse}
				responseSubmitted={responseSubmitted}
				displayTooltip={firstLikert3Sides}
				setDisplayTooltip={setFirstLikert3Sides}
			/>
		);
		AnswerComponent = <Likert3SidesAnswer answer={answer} />;
	}

	return (
    <body className="display-container pt-8">
      <AboutGameScoreModal isOpen={isModalOpen} isClose={closeModal} />
      <nav
        className="navbar navbar-light fixed-top container-fluid"
        id="header-div">
        <Header
          timeline={timeline}
          score={score}
          responseSubmitted={responseSubmitted}
          scoreChange={scoreChange}
          onButtonClick={openModal}
        />
      </nav>

      <Grid container>
        <Grid item xs={1} className="sticky-game-stop-sidebar">
          <div className="sticky-game-stop-bar">
            <GameStopSideBar
              gameStopNumber={gameStopNumber}
              timeline={timeline}
              currentNumber={currentNumber}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={11}
          className="container-fluid response-answer-container"
          role="region"
          aria-label="Survery Information">
          <h1
            id="question-div"
            className="survey-question"
            aria-label="Survey Question">
            {surveyQuestion}
          </h1>
          <Grid container className="mt-2">
            <Grid item xs className="mr-5">
              <div className="survey-info mb-3">
                <strong>Poll Information</strong>
                <div className="survey-who-when">
                  <strong>Who: </strong>
                  <span>{surveyAudience}</span>
                </div>
                <div className="survey-who-when">
                  <strong>When: </strong>
                  <span>
                    {surveyStartDate} - {surveyEndDate}
                  </span>
                  <div>
                    {questionHasCutOff ? (
                      <strong>
                        <i>Top {answer.length} responses shown</i>
                      </strong>
                    ) : null}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs className="ml-5">
              <div className="survey-info mb-3">
                {showAnswer && (
                  <div>
                    <strong>
                      Survey Respondents Say:
                      <br />
                    </strong>
                    {questionDisplayFormat ===
                      questionDisplayFormatEnum.PERCENTAGE_GUESS ||
                    questionDisplayFormat ===
                      questionDisplayFormatEnum.LIKERT_2_SIDES ||
                    questionDisplayFormat ===
                      questionDisplayFormatEnum.LIKERT_3_SIDES ||
                    questionDisplayFormat === questionDisplayFormatEnum.PIE ? (
                      <>
                        <div className="footnote">
                          Total percentages may sum to +/- 100% due to rounding.
                        </div>
                      </>
                    ) : null}
                    <QuestionInfo
                      className="footnote"
                      startDate={surveyStartDate}
                      endDate={surveyEndDate}
                      surveyAudience={surveyAudience}
                      surveyOrganization={surveyOrganization}
                      surveySponsor={surveySponsor}
                    />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
          <Grid className="response-answer-container" container>
            <Grid item xs>
              {ResponseComponent}
              {questionDisplayFormat ===
                questionDisplayFormatEnum.PERCENTAGE_GUESS ||
              questionDisplayFormat ===
                questionDisplayFormatEnum.LIKERT_2_SIDES ||
              questionDisplayFormat ===
                questionDisplayFormatEnum.LIKERT_3_SIDES ? (
                <Legend legends={responseLegends} />
              ) : null}
              {responseSubmitted ||
              questionDisplayFormat === questionDisplayFormatEnum.TOP_1 ||
              questionDisplayFormat === questionDisplayFormatEnum.RANK_ALL ||
              questionDisplayFormat === questionDisplayFormatEnum.PIE ? null : (
                <div className="lock-in-btn-wrapper">
                  <Button
                    className="button-primary"
                    aria-label="View actual responses"
                    onClick={(e) => {
                      handleLockInResponse(response, e);
                    }}>
                    View actual responses
                  </Button>
                </div>
              )}
            </Grid>
            <Divider
              className="divider ml-5 mr-5"
              orientation="vertical"
              variant="middle"
              flexItem
            />
            {showAnswer ? (
              <Grid item xs>
                {AnswerComponent}
                {questionDisplayFormat ===
                  questionDisplayFormatEnum.PERCENTAGE_GUESS ||
                questionDisplayFormat ===
                  questionDisplayFormatEnum.LIKERT_2_SIDES ||
                questionDisplayFormat ===
                  questionDisplayFormatEnum.LIKERT_3_SIDES ? (
                  <Legend legends={answerLegends} />
                ) : null}
                <div className="btn-wrapper">
                  {responseSubmitted ? (
                    <Button
                      className="button-primary"
                      aria-label="next question"
                      disabled={!responseSubmitted}
                      onClick={handleNextQuestion}>
                      Next
                      <ChevronRightIcon />
                    </Button>
                  ) : null}
                </div>
              </Grid>
            ) : (
              <Grid item xs>
                <div className="answer-cover">
                  <img
                    className="question-img"
                    src={questionMark}
                    alt={"roper center question mark logo"}
                  />
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* <ScorePopUp open={scorePopUpOpen} handleClose={handleScorePopUpClose} score={score}/> */}
    </body>
  );
}

export default Display;
